import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@99designs/common/components/Icon';
import { IconButton } from '@99designs/common/components/IconButton';
import ToggleButton from 'components/ToggleButton';
import { toggleRequest } from 'utils/xhr';

const FavoriteButton = ({ isFavorite, favoriteUrl, onFavorite }) => (
    <ToggleButton
        isToggled={isFavorite}
        xhrUrl={favoriteUrl}
        toggleRequest={toggleRequest}
        onSuccess={onFavorite}
        render={({ isToggled, onToggle }) => (
            <IconButton
                variations={['soft-toggle', classNames({ selected: isToggled })]}
                onClick={onToggle}
            >
                <Icon type={'heart-1'} />
            </IconButton>
        )}
    />
);

FavoriteButton.defaultProps = {
    onFavorite: () => undefined,
};

FavoriteButton.propTypes = {
    isFavorite: PropTypes.bool.isRequired,
    favoriteUrl: PropTypes.string.isRequired,
    onFavorite: PropTypes.func,
};

export default FavoriteButton;



// WEBPACK FOOTER //
// ./src/js/components/FavoriteButton.jsx